/** Bouton « ? » de relance d'un tutoriel. */
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";

export const TourButton = ({
  onClick,
  className = "",
}: {
  onClick: () => void;
  className?: string;
}) => {
  const { t } = useTranslation();
  const label = t("tour-replay");

  return (
    <button
      type="button"
      onClick={onClick}
      className={`shrink-0 inline-flex items-center justify-center w-8 h-8 rounded-full text-grey-medium hover:text-tertiary hover:bg-grey-light/60 transition-colors ${className}`}
      aria-label={label}
      title={label}
    >
      <FontAwesomeIcon icon="circle-question" className="text-lg" />
    </button>
  );
};
